import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// import HOSTS from '@ui/services/common/hosts';
import webLogin from '@utils/weblogin';
import qs from 'qs';
var NFTAPI = {
  authData: webLogin.getAuthentication(),
  axiosClient: function axiosClient(path, params) {
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
    this.authData = webLogin.getAuthentication();
    var baseParam = {};
    var baseData = _objectSpread({
      h5: 1,
      thirdchannel: 6,
      token: this.authData.token,
      tuid: this.authData.uid,
      uid: this.authData.uid,
      androidid: this.authData.deviceID
    }, params);
    if (method === 'post') {
      baseParam.headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };
      // baseData.param = JSON.stringify(params);
      baseParam.data = qs.stringify(baseData);
    } else {
      baseParam.params = baseData;
    }
    var baseUrl = window.ISONLINE ? window.HTTPUrl.live : window.HTTPUrl.live_test;
    return window.KEWLHttp("".concat(baseUrl).concat(path), _objectSpread({
      // TODO: 是否修复？？
      // return window.KEWLHttp(`${path}`, {
      method: method
    }, baseParam));
  },
  getNFTStatus: function getNFTStatus() {
    this.authData = webLogin.getAuthentication();
    console.info('this.authData', this.authData);
    return this.axiosClient('/nft/getNFTStatus', {
      user_id: this.authData.uid
    });
  } // bindEthereum(address, addressName, message, sign, chainId) {
  //   return this.axiosClient('http://featuremix-qa.live.liveme.com/nft/bindEthereum', {
  //     address,
  //     address_name: addressName,
  //     source: 'h5',
  //     message,
  //     ethereum_sign: sign,
  //     chain_id: chainId,
  //   });
  // },
  // unbindEthereum(address) {
  //   return this.axiosClient('http://featuremix-qa.live.liveme.com/nft/unBindEthereum', {
  //     address,
  //   });
  // },
  // getNonce(address, chainId) {
  //   return this.axiosClient('http://featuremix-qa.live.liveme.com/nft/createEthereum', {
  //     address,
  //     chain_id: chainId || '',
  //   });
  // },
};
export default NFTAPI;